<template>
  <div class="jhyjDetail-wrap">
    <div class="index-info">
      <h2>{{indexInfo.indexnameG? indexInfo.indexnameG : indexInfo.indexname}}</h2>
      <div class="info">
        {{indexInfo.updateFreqStr}}频<i>·</i>{{today}}
      </div>
      <div class="chart-line" v-if="JSON.stringify(indexDetail) != '{}'">
        <ChartLine :index = "1" :factorId="indexId" :star="indexDetail.dayWeekMonth" />
      </div>
    </div>
    <div class="top-stock" v-if="topStockList.length>0">
      <span v-for="(item, index) in topStockList" :key="item.stockCode" :class="{cur: topStockIndex === index}" @click="changeTopStock(index)">{{item.name}}</span>
      <strong class="menu" @click="isPopStock = true" v-if="popStockList.length>4"></strong>
    </div>
    <div class="stock-info" v-if="topStockList.length>0">
      <div class="inner">
        <div class="top-con">
          <div class="stock-name">
            <span>股票代码</span>
            <span>{{topStockList[topStockIndex].code}}</span>
            <strong class="star">
              <i
                v-for="(star, index) in 3" :key="index"
                :class="{active: index < Math.abs(topStockList[topStockIndex].star),yellow: topStockList[topStockIndex].star <0}"
                >
              </i>
            </strong>
          </div>
          <div class="time">{{ topStockList[topStockIndex].repDate }}营收</div>
        </div>
        <div class="zf" :class="{'font-green': topStockList[topStockIndex].yoy <0,'font-red': topStockList[topStockIndex].yoy >0}">
          <span>{{formatMoney(topStockList[topStockIndex].revenue)}}</span>
          <i>/</i>
          <span>{{toFixed(topStockList[topStockIndex].yoy)}}%</span>
          <img src="../assets/images/arrow-red.png" alt="" v-if="topStockList[topStockIndex].tagrt >0">
          <img src="../assets/images/arrow-red.png" alt="" v-else>
        </div>
      </div>
    </div>
    <div class="pop-stock" v-show="isPopStock" @click="isPopStock = false">
      <div class="pop-con" @click.stop="isPopStock = true">
        <span v-for="(item,index) in popStockList" :key="item.stockCode" :class="{cur: popStockIndex === index}" @click.stop="selectStock(index)">{{item.name}}</span>
      </div>
    </div>
    <div class="mod mod-price">
      <div class="title">
        <span>价格走势</span>
      </div>
      <div class="legend">
        <span class="stock-icon" v-if="popStockList.length>0">{{topStockList[topStockIndex].name}}</span>
        <span class="index-icon">{{indexInfo.indexnameG? indexInfo.indexnameG : indexInfo.indexname}}</span>
        <!-- <i class="unit">元</i> -->
      </div>
      <div class="chart-KLine" v-if="popStockList.length>0" >
        <ChartKLine2 :stockCode = "topStockList[topStockIndex].code" :stockName="topStockList[topStockIndex].name" :historyData="historyData"/>
      </div>
      <div class="chart-Line"  v-if="topStockList.length == 0">
        <ChartLine2/>
      </div>
      <div class="data-title" v-show="topStockList.length > 0">
        <span v-for="(nav, index) in priceTitle" :key="index">{{nav}}</span>
      </div>
      <ul class="data-list" v-show="topStockList.length > 0">
        <li v-if="JSON.stringify(indexDetail) != '{}'">
          <span class="index-icon">指标</span>
          <span>{{indexDetail.date}}</span>
          <span>{{toFixed(indexDetail.price)}}</span>
          <span>{{toFixed(indexDetail.latestValue)}}%</span>
          <span v-show="indexDetail.dayWeekMonth !=''">{{toFixed(indexDetail.dayWeekMonth)}}%</span>
        </li>
        <li v-if="JSON.stringify(pchgDetail) != '{}'">
          <span class="stock-icon">{{topStockList[topStockIndex].name}}</span>
          <span>{{pchgDetail.date}}</span>
          <span>{{toFixed(pchgDetail.price)}}</span>
          <span>{{toFixed(pchgDetail.latestValue)}}%</span>
          <span v-show="indexDetail.dayWeekMonth !=''">{{toFixed(pchgDetail.dayWeekMonth)}}%</span>
        </li>
      </ul>
    </div>
    <div class="mod mod-history" v-if="historyData.length > 0">
      <div class="title">
        <span>历史数据</span>
      </div>
      <div class="data-title">
        <span v-for="(nav, index) in historyTitle" :key="index">{{nav}}</span>
      </div>
      <ul class="data-list">
        <li v-for="(item, index) in historyData" :key="index">
          <span>{{index +1}}</span>
          <span>{{item.reportTime}}</span>
          <span>{{toFixed(item.currentValue)}}</span>
          <span>{{item.latestNFreq}}</span>
          <span>{{toFixed(item.latestValue)}}{{item.latestUnit}}</span>
        </li>
      </ul>
    </div>
    <div class="mod" v-show="topStockList.length > 0">
      <div class="title">
        <span>经营图谱</span>
        <em @click="goTp">更多</em>
      </div>
      <div class="tp-tips" @click="goTp">
        <p>共{{yzNum}}个经营因子，点击查看更多</p>
        <img src="../assets/images/vip-icon.png" alt="" v-if="themeStyleVs == 1">
        <img src="../assets/images/black/vip-icon.png" alt="" v-else>
      </div>
      <iframe :src="ifameUrl" frameborder="0" class="ifame" v-if="ifameUrl"></iframe>
    </div>
    <div class="backTop" @click="backTop"></div>
  </div>
</template>

<script>
import ChartKLine2 from '../components/ChartKLine2.vue'
import ChartLine from '../components/ChartLine.vue'
import ChartLine2 from '../components/ChartLine2.vue'
export default {
  components: {
    ChartKLine2,
    ChartLine,
    ChartLine2,
  },
  data() {
    return {
      token: '',
      indexId: '',
      freq: '',
      topStockIndex: 0,
      topStockList: [],
      popStockIndex: 0,
      popStockList: [],
      isPopStock: false,
      ifameUrl: '',
      historyTitle: ['序号', '日期', '最新价', 'T+N期', '近N日涨跌幅'],
      historyData: [],
      priceTitle: ['名称', '日期','价格', '变动值', '近一周变化'],
      indexDetail: {},
      pchgDetail: {},
      yzNum: 0,
      themeStyleVs: '',
      indexInfo: {},
      today: '',
      indexName: '',
    }
  },
  created() {
    // this.token = this.$store.state.token
    this.token = this.$route.query.token
    this.themeStyleVs = this.$route.query.themeStyleVs
    this.today = this.getToday(new Date(), '-')
    // console.log(localStorage.getItem('token'))
    this.indexId = this.$route.query.indexId
    this.getIndexInfo()
    this.getStock()
  },
  mounted() {
    // this.$nextTick(()=>{
    //   var stockTop = document.querySelector(".top-stock").offsetTop
    //   console.log(stockTop)
    // })
  },
  methods: {
    // 获取指标信息
    getIndexInfo() {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          factorId: this.indexId,
        }
      }
       this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/rf/fm/idx',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=>{
        if (res.data.code == 0) {
          this.indexInfo  = res.data.data
          this.freq = this.indexInfo.updateFreq

        }
      })
    },
    // 获取头部股票列表
    getStock () {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          factorId: this.indexId,
        }
      }
      this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/rf/pld/page',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=>{
        if (res.data.code == 0) {
          if (res.data.data.total > 0) {
            this.popStockList = res.data.data.data.slice(0, 15)
            this.topStockList = this.popStockList.slice(0, 4)
            this.ifameUrl = `${window.config.qytp_link}/yjtp/map.html?token=${this.token}&code=${this.topStockList[this.topStockIndex].code}&themeStyleVs=${this.themeStyleVs}`
            this.$nextTick(()=>{
              var stockTop = document.querySelector(".top-stock").offsetTop
              window.onscroll = () =>{
                var docTop = document.documentElement.scrollTop
                if (docTop >= stockTop) {
                  document.querySelector(".jhyjDetail-wrap").classList.add("fixed")
                } else {
                  document.querySelector(".jhyjDetail-wrap").classList.remove("fixed")

                }
              }
            })
            this.getIndexStockDetail()
            this.getIndexDetail()
            this.getYzNum()
          }
          else {
            console.log('关联股票为空')
            this.getIndexDetail()
          }
        }
      })
    },
    // 切换头部4种股票
    changeTopStock (i) {
      this.topStockIndex = i
      this.ifameUrl = `${window.config.qytp_link}/yjtp/map.html?token=${this.token}&code=${this.topStockList[this.topStockIndex].code}&themeStyleVs=${this.themeStyleVs}`
      this.getIndexStockDetail()
      this.getYzNum()
    },
    // 选择弹框股票
    selectStock(i) {
      this.popStockList.forEach((element, index) => {
        if (element.code === this.topStockList[this.topStockIndex].code) {
          this.popStockIndex = index
        }
      });
      this.popStockIndex = i
      if (i < 4 && i !=0) {
        this.topStockIndex = i
      } else {
        this.topStockList[0] = this.popStockList[i]
        this.topStockIndex = 0
      }
      this.isPopStock = false
      this.ifameUrl = `${window.config.qytp_link}/yjtp/map.html?token=${this.token}&code=${this.topStockList[this.topStockIndex].code}&themeStyleVs=${this.themeStyleVs}`
      this.getIndexStockDetail()
      this.getYzNum()
    },
    // 格式化money
    formatMoney(val) {
      var value = ''
      var num = Math.floor(val).toString()
      if (num.length > 4)  {
        if (num.length > 8) {
          value = (val / 100000000).toFixed(2) + '亿'
        } else {
          value = (val / 10000).toFixed(2) + '万'
        }
      } else {
        value = val
      }
      return value
    },
    // 获取指标近期数据
    getIndexDetail() {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          indexId: this.indexId,
          date: this.today
        }
      }
      this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/report/indexDetailList',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=>{
        if (res.data.code == 0 && res.data.data) {
          this.historyData = res.data.data
        }
      })
    },
    // 获取指标和股票最近一条数据
    getIndexStockDetail() {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          stock: this.topStockList[this.topStockIndex].code,
          indexId: this.indexId,
          date: this.today
        }
      }
      this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/report/stockAndIndexDetail',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=>{
        if (res.data.code == 0) {
          if (this.freq == 86400) { // 日频
              this.priceTitle[4] = '近一周变化'
            } else if (this.freq == 604800){ //周频
              this.priceTitle[4] = '近一月变化'
            } else {
              this.priceTitle[4] = ''
            }
          if (res.data.data.indexDetail) {
            this.$set(this.indexDetail, 'date', res.data.data.indexDetail.reportTime)
            this.$set(this.indexDetail, 'price', res.data.data.indexDetail.currentValue)
            this.$set(this.indexDetail, 'latestValue', res.data.data.indexDetail.latestValue)
            if (this.freq == 86400) { // 日频
              this.$set(this.indexDetail, 'dayWeekMonth', res.data.data.indexDetail.weeklyVariation)
              this.priceTitle[4] = '近一周变化'
            } else if (this.freq == 604800){ //周频
              this.$set(this.indexDetail, 'dayWeekMonth', res.data.data.indexDetail.monthlyVariation)
              this.priceTitle[4] = '近一月变化'
            } else {
              this.indexDetail.dayWeekMonth = ''
              this.priceTitle[4] = ''
            }
          }
          if (res.data.data.pchgDetail) {
            var date = res.data.data.pchgDetail.tradeDate;
            this.$set(this.pchgDetail, 'date', date.slice(0,4)+'-'+date.slice(4,6)+'-'+date.slice(6,8))
            this.pchgDetail.date = date.slice(0,4)+'-'+date.slice(4,6)+'-'+date.slice(6,8)
            this.$set(this.pchgDetail, 'price', res.data.data.pchgDetail.tclose)
            this.$set(this.pchgDetail, 'latestValue', res.data.data.pchgDetail.pchg1b)
            if (this.freq == 86400) { // 日频
              this.$set(this.pchgDetail, 'dayWeekMonth', res.data.data.pchgDetail.pchg5b)
            } else if (this.freq == 604800){ //周频
              this.$set(this.pchgDetail, 'dayWeekMonth', res.data.data.pchgDetail.pchg20b)
            } else {
              this.pchgDetail.dayWeekMonth = ''
            }
          }
        }
      })
    },
    // 企业图谱更多
    goTp() {
      var url = window.config.qytp_link + `/yjtp/yzty.html?code=${this.topStockList[this.topStockIndex].code}&DZHSPECIAL=285`
      this.toUrl(url);
    },
    getYzNum () {
      var postParam = {
        qid: new Date().getTime(),
        pageNum: 1,
        pageSize: 1,
        param: {
          stock: this.topStockList[this.topStockIndex].code
        }
      }
      this.$http({
        method: 'post',
        url: window.config.research_server + '/research-framework-server/rf/pld/page',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then(res=>{
        if (res.data.code == 0 && res.data.data.data) {
          this.yzNum = res.data.data.data[0].dataNodeNum
        } else {
          this.yzNum = 0
        }
      })
    },
    // 回到顶部
    backTop () {
      window.scrollTo(0, 0)
    }
  },

}
</script>
<style lang="scss" scoped>
.jhyjDetail-wrap{
  // background: #F7F7FC;
  &.fixed{
    padding-top: 0.51rem;
    .top-stock{
      position: fixed;
      left: 0rem;
      right: 0rem;
      top: 0rem;
    }
  }
  .top-stock{
    display: flex;
    background: #fff;
    padding: 0.06rem 0.16rem 0.14rem;
    z-index: 2;
    position: relative;
    span{
      width: 22.5%;
      font-size: 0.14rem;
      color: #555;
      border-radius: 0.06rem;
      border: 1px solid #E5E5E5;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 0.31rem;
      +span{
        margin-left: 0.07rem;
      }
      &.cur{
        position: relative;
        border: none;
        &:after{
          content: '';
          width: 100%;
          height: 0.4rem;
          background: url(../assets/images/stock-bg.png) no-repeat;
          background-size: 100% auto;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
    .menu{
      position: absolute;
      right: 0rem;
      top: 0.06rem;
      width: 0.54rem;
      height: 0.31rem;
      background: url(../assets/images/stock-menu.png) no-repeat;
      display: block;
      background-size: 100% auto;
    }
  }
  .stock-info{
    background: #fff;
    padding: 0 0.16rem 0.1rem;
    .inner{
      border-radius: 0.06rem;
      background: #F8F8F8;
      padding: 0.08rem 0.12rem;
    }
    .top-con{
      display: flex;
      justify-content: space-between;
      font-size: 0.12rem;
      color: #999;
      align-items: center;
      span{
        margin-right: 0.04rem;
      }
      .stock-name{
        display: flex;
        align-items: center;
        span{
          margin-top: 0.03rem;
          line-height: 1;
        }
      }
    }
    .zf{
      font-size: 0.14rem;
      margin-top: 0.04rem;
      display: flex;
      align-items: center;
      &.font-red{
        color: #F54D5B;
      }
      &.font-green{
        color: #1EAC4E;
      }
      i{
        margin: 0 0.04rem;
      }
      img{
        width: 0.12rem;
      }
    }
  }
  .pop-stock{
    position: fixed;
    left: 0;
    right: 0;
    top: 0rem;
    bottom: 0;
    background: rgba(0, 0, 0, 0.40);
    z-index: 10;
    .pop-con{
      background: #fff;
      padding: 0.08rem 0.16rem 0.12rem;
      span{
        width: 23%;
        font-size: 0.14rem;
        color: #555;
        border-radius: 0.06rem;
        border: 1px solid #E5E5E5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 0.31rem;
        margin-bottom: 0.12rem;
        +span{
          margin-left: 0.09rem;
        }
        &:nth-child(4n +1) {
          margin-left: 0;
        }
        &.cur{
          border: 1px solid #286DF7;
          background: rgba(40, 109, 247, 0.06);
        }
      }
    }
  }
  .mod{
    background: #fff;
    padding: 0.16rem 0.16rem;
  }
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.16rem;
    span{
      font-size: 0.16rem;
      color: #222;
      font-weight: bolder;
      position: relative;
      padding-left: 0.12rem;
      &:before{
        content: '';
        display: inline-block;
        width: 0.04rem;
        height: 0.14rem;
        border-radius: 0.28rem;
        background: #286DF7;
        position: absolute;
        left: 0;
        top: 0.04rem;
      }
    }
    em{
      font-size: 0.12rem;
      color: #999;
      &:after{
        @include arrow(5px, #999);
        vertical-align: middle;
        margin-left: 3px;
      }
    }
  }
  .ifame{
    width: 100%;
    height: 6.5rem;
  }
  .data-title{
    background: #FAFAFA;
    height: 0.36rem;
    display: flex;
    align-items: center;
    font-size: 0.12rem;
    color: #999;
  }
  .mod-history{
    .data-title, .data-list, li{
      span{
        text-align: center;
        &:nth-child(1) {
          width: 14%;
        }
        &:nth-child(2) {
          width: 24%;
        }
        &:nth-child(3) {
          width: 22%;
        }
        &:nth-child(4) {
          width: 16%;
        }
        &:nth-child(5) {
          flex: 1;
        }
      }
    }
    .data-list{
      li{
        height: 0.48rem;
        display: flex;
        align-items: center;
        &:nth-child(even) {
          background: #FAFAFC;
        }
        span{
          font-size: 0.12rem;
          color: #555;
          text-align: center;
        }
      }
    }
  }
  .mod-price{
    .legend{
      font-size: 0.12rem;
      color: #999;
      position: relative;
      span{
        position: relative;
        +span{
          margin-left: 0.1rem;
        }
        &.index-icon{
          padding-left: 0.16rem;
          &:after{
            content: '';
            display: inline-block;
            width: 0.1rem;
            height: 0.04rem;
            border-radius: 0.28rem;
            background: #286DF7;
            position: absolute;
            left: 0rem;
            top: 0.04rem;
          }
        }
        &.stock-icon{
          padding-left: 0.2rem;
          &:before{
            content: '';
            display: inline-block;
            width: 0.16rem;
            height: 0.08rem;
            background: url(../assets/images/stock-icon.png) no-repeat;
            background-size: 100% auto;
            position: absolute;
            left: 0rem;
            top: 0.02rem;
          }
        }
      }
      .unit{
        position: absolute;
        right: 0.14rem;
        top: 0.14rem;
        font-size: 0.1rem;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .data-title, .data-list, li{
      span{
        text-align: center;
        &:nth-child(1) {
          width: 23%;
        }
        &:nth-child(2) {
          width: 20%;
        }
        &:nth-child(3) {
          width: 17%;
        }
        &:nth-child(4) {
          width: 17%;
        }
        &:nth-child(5) {
          flex: 1;
        }
      }
    }
    .data-title{
      background: #F6F6F6;
      span{
        &:nth-child(1) {
          text-align: left;
          padding-left: 0.14rem;
        }
      }

    }
    .data-list{
      li{
        height: 0.48rem;
        display: flex;
        align-items: center;
        background: #FBFBFB;
        span{
          font-size: 0.12rem;
          color: #555;
          text-align: center;
          position: relative;
          line-height: 1;
          &:nth-child(1) {
            text-align: left;
            padding-left: 0.28rem;
          }
          &.index-icon{
            &:after{
              content: '';
              display: inline-block;
              width: 0.1rem;
              height: 0.04rem;
              border-radius: 0.28rem;
              background: #286DF7;
              position: absolute;
              left: 0.14rem;
              top: 0.04rem;
            }
          }
          &.stock-icon{
            padding-left: 0.28rem;
            &:before{
              content: '';
              display: inline-block;
              width: 0.16rem;
              height: 0.08rem;
             background: url(../assets/images/stock-icon.png) no-repeat;
             background-size: 100% auto;
             position: absolute;
             left: 0.1rem;
            top: 0.02rem;
            }
          }
        }
      }
    }
  }
  .tp-tips{
    background: #F9F9F9;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.33rem;
    font-size: 0.12rem;
    color: #286DF7;
    img{
      width: 0.2rem;
      margin-left: 2px;
    }
  }
  .chart-KLine,.chart-Line{
    width: 100%;
    height: 2.5rem;
    margin-bottom: 0.2rem;
  }
  .backTop{
    width: 0.43rem;
    height: 0.43rem;
    background: url(../assets/images/backTop.png) no-repeat;
    background-size: 100% auto;
    position: fixed;
    right: 0.2rem;
    bottom: 0.5rem;
  }
}
.index-info{
  position: relative;
  padding: 0.12rem 0.16rem;
  background: #FFF;
  margin-bottom: 0.08rem;
  h2{
    font-size: 0.16rem;
    color: #222;
    @include line-clamp(2);
    width: 74%;
    height: 0.44rem;
    line-height: 0.22rem;
    margin-bottom: 0.24em;
    &.w100{
      width: 100%;
    }
  }
  .tag{
    font-size: 0.12rem;
    color: #999;
    margin: 0.05rem 0 0.08rem;
    display: flex;
    align-items: center;
    p{
      margin-right: 0.08rem;
      i{
        margin: 0 2px;
        font-weight: bold;
      }
    }
  }
  .info{
    height: 0.22rem;
    padding: 0 0.08rem;
    border-radius: 0.04rem;
    background: #FAFAFA;
    color: #999;
    font-size: 0.12rem;
    line-height: 0.22rem;
    em{
      color: #3B85FE;
    }
    i{
      margin: 0 2px;
      font-weight: bold;
    }
  }
  .chart-line{
    position: absolute;
    width: 0.76rem;
    height: 0.4rem;
    right: 0.1rem;
    top: 0.16rem;
  }
}
.blackTheme {
  .jhyjDetail-wrap{
    background: #171922;
    .top-stock{
      background: #171922;
      span{
        color: #AAB9D1;
        border: 1px solid #2B2F3D;
        &.cur{
          border: none;
          &:after{
            content: '';
            background: url(../assets/images/black/stock-bg.png) no-repeat;
            background-size: 100%;
          }
        }
      }
      .menu{
        background: url(../assets/images/black/stock-menu.png) no-repeat;
        background-size: 100%;
      }
    }
    .stock-info{
      background: #171922;
      .inner{
        background: #272935;
      }
      .top-con{
        color: #6B7687;
      }
      .zf{
        &.font-red{
          color: #EF3939;
        }
        &.font-green{
          color: #0BAF80;
        }
      }
    }
    .pop-stock{
      background: rgba(0, 0, 0, 0.50);
      .pop-con{
        background: #171922;
        span{
          color: #AAB9D1;
          border: 1px solid #2B2F3D;
          &.cur{
            border: 1px solid #3B85FE;
            background:  rgba(59, 133, 254, 0.06);
          }
        }
      }
    }
    .mod{
      background: #171922;
    }
    .title{
      span{
        color: #E4E9FE;
        &:before{
          background: #3B85FE;
        }
      }
      em{
        color: #999;
        &:after{
          @include arrow(5px, #999);
        }
      }
    }
    .data-title{
      background: #1C1E28;
      color: #6B7687;
    }
    .mod-history{
      .data-list{
        li{
          &:nth-child(even) {
            background: #1C1E28;
          }
          span{
            color: #AAB9D1;
          }
        }
      }
    }
    .mod-price{
      .legend{
        color: #6B7687;
        span{
          &.index-icon{
            &:after{
              background: #3B85FE;
            }
          }
          &.stock-icon{
            &:before{
              background: url(../assets/images/black/stock-icon.png) no-repeat;
              background-size: 100% auto;
            }
          }
        }
        .unit{
          color: rgba(0, 0, 0, 0.25);
        }
      }
      .data-title{
        background: #20222C;
      }
      .data-list{
        li{
          background: #1C1E27;
          span{
            color: #AAB9D1;
            &.index-icon{
              &:after{
                background: #3B85FE;
              }
            }
            &.stock-icon{
              &:before{
                background: url(../assets/images/black/stock-icon.png) no-repeat;
                background-size: 100% auto;
              }
            }
          }
        }
      }
    }
    .tp-tips{
      background: #272935;
      color: #3B85FE;
    }
    .backTop{
      background: url(../assets/images/black/backTop.png) no-repeat;
      background-size: 100% auto;
    }
  }
  .index-info{
    background: #171922;
    &.visited{
      h2{
        color: #6B7687;
      }
    }
    &:before{
      @include border(top, #1E1F29);
    }
    h2{
      color: #E4E9FE;
    }
    .tag{
      color: #6B7687;
    }
    .info{
      background: #1E1F29;
      color: #6B7687;
      em{
        color: #3B85FE;
      }
    }
  }
}

</style>